<template>
  <div
    class="result-item community"
    data-cy="community-search-result"
    @click="click"
  >
    <v-image
      v-if="community.idImage"
      :image-id="community.idImage"
    />
    <div v-else>
      <img src="@/assets/DefaultCommunityVisual.png" />
    </div>
    <div class="item-info">
      <community-search :community="community" />
    </div>
  </div>
</template>

<script>
import CommunitySearch from './CommunitySearch'
import VImage from '../shared/VImage'

export default {
  name: 'SearchResultCommunityItem',
  components: { CommunitySearch, VImage },
  props: {
    community: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      default: () => undefined
    }
  },
  methods: {
    click() {
      if (this.onClick) {
        this.onClick()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
img {
  width: 100px;
  height: 75px;
  object-fit: cover;
  object-position: 20% 20%;
}

.result-item {
  display: flex;
  padding: 15px 0;
  cursor: pointer;

  &.community {
    align-items: flex-start;
  }

  .item-info {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: $black-color;
    font-size: 15px;
    margin-left: 10px;
    max-width: 750px;
  }
}

</style>
